/**
 * Phase 5f/5i ÔÇö Produkte lesen: Domain-Aggregat-Index + merged Blob.
 */

import { listAggregateProducts } from '../infrastructure/storage/domainAggregateStore';
import { listEntityProducts } from '../infrastructure/storage/entityAggregateStore';
import { readBlobFirstWithAggregateFallback } from './canonicalEntityRead';
import { readSyncWithBlobPriority, readArrayFieldFromMergedBlob } from './businessStateSync';

/** @type {Map<string, object[]>} */
const productsReadCache = new Map();

export function readProductsFromMergedBlob(businessId) {
  return readArrayFieldFromMergedBlob(businessId, 'products', getCachedProductsRead);
}

/**
 * @param {string} businessId
 * @returns {Promise<object[]>}
 */
export async function readProductsFromBestSource(businessId) {
  return readBlobFirstWithAggregateFallback(
    businessId,
    readProductsFromMergedBlob,
    listAggregateProducts,
    listEntityProducts,
    ['id', 'productId']
  );
}

export async function refreshProductsReadCache(businessId, preloaded) {
  const products =
    preloaded !== undefined
      ? Array.isArray(preloaded)
        ? preloaded
        : []
      : await readProductsFromBestSource(businessId);
  if (businessId) {
    productsReadCache.set(String(businessId), products);
  }
  return products;
}

export function getCachedProductsRead(businessId) {
  if (!businessId) return null;
  return productsReadCache.get(String(businessId)) ?? null;
}

export function clearProductsReadCache(businessId) {
  if (businessId) {
    productsReadCache.delete(String(businessId));
  } else {
    productsReadCache.clear();
  }
}

export function seedProductsReadCache(businessId, products) {
  if (!businessId || products === undefined) return;
  productsReadCache.set(String(businessId), Array.isArray(products) ? products : []);
}

/** Synchroner Lesepfad (Cache Ôê¬ Blob, Blob-Priorit├ñt). */
export function readProductsSyncForBusiness(businessId) {
  return readSyncWithBlobPriority(
    businessId,
    readProductsFromMergedBlob,
    getCachedProductsRead,
    'id',
    'productId'
  );
}
